import { render, staticRenderFns } from "./TopRecognisersTable.vue?vue&type=template&id=e38732d6&scoped=true&"
import script from "./TopRecognisersTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopRecognisersTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TopRecognisersTable.vue?vue&type=style&index=0&id=e38732d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38732d6",
  null
  
)

export default component.exports